export default __webpack_public_path__ + "static/media/arrow-up.6891e5da.svg";